import { ReactNode } from 'react'

import TripleDotPopupWrapper from 'common/components/TripleDotPopupWrapper'

interface IGraphContainerCardProps {
  children: ReactNode
  title: string
  optionsComponent?: ReactNode
  dropdownSectionRenderer?: () => JSX.Element
}

/**
 * Card component to decorate each graph with title and options.
 *
 * @param title title to display at top left of card
 * @param optionsComponent component to show at top right of card
 * @param children content to display within the card below header
 */
const GraphContainerCard = ({
  title,
  optionsComponent,
  dropdownSectionRenderer,
  children
}: IGraphContainerCardProps) => {
  return (
    <div
      key={title}
      className='flex h-full flex-col rounded bg-white shadow-[0_2px_4px_0_theme(colors.black)21]'
    >
      <div
        className={[
          'flex items-center justify-between',
          'px-6 py-2 h-12',
          'border-b border-gray-200'
        ].join(' ')}
      >
        <div className='font-bold'>{title}</div>
        <div className='flex'>
          {optionsComponent != null && optionsComponent}
          <TripleDotPopupWrapper
            dropdownSectionRenderer={dropdownSectionRenderer}
          />
        </div>
      </div>
      <div className='flex-1 p-4'>{children}</div>
    </div>
  )
}

export default GraphContainerCard
